import {
    deleteZancaSortDeviceDetails,
    fetchZancaSortDeviceDetails,
    setZancaSortDeviceDetails, updateZancaSortConfiguration,
    updateZancaSortDeviceDetails,
    updateZancaSortDeviceMac,
    updateZancaSortMonitoringDetails
} from "../network/ZancaSortDeviceNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const ZancaSortDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            fetchZancaSortDeviceDetails(action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setZancaSortDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateZancaSortDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateZancaSortDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "UPDATE_MONITORING_DATA":
            updateZancaSortMonitoringDetails(action.data.dispatcher, action.data.stateValues,
                action.data.mac)
            return state
        case "DELETE_DEVICE_DATA":
            deleteZancaSortDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "UPDATE_ZANCA_SORT_CONFIGURATION":
            updateZancaSortConfiguration(action.data.dispatcher, action.data.configurations,
                action.data.mac,  action.data.showCustomAlert)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/reducer/ZancaSortDeviceOverviewReducer.js